export default __webpack_public_path__ + "static/media/banner_2.f2014b69.png";